import { Navigate, useParams } from 'react-router-dom';
import NoticeFormWrapper from './NoticeFormWrapper';
import { isLegalMailingEnabled } from 'src/utils/featureFlags';

export const NoticeFormGuardWrapper = () => {
  const { type } = useParams();

  const allowedTypes = ['notice-bk', 'direct', ...(isLegalMailingEnabled() ? ['legal'] : [])];
  if (!allowedTypes.includes(type ?? '')) {
    return <Navigate to="/" replace />;
  }

  return <NoticeFormWrapper />;
};
